import { render, staticRenderFns } from "./SentCurriculumList.vue?vue&type=template&id=404a3f0f&scoped=true&lang=pug"
import script from "./SentCurriculumList.vue?vue&type=script&lang=js"
export * from "./SentCurriculumList.vue?vue&type=script&lang=js"
import style0 from "./SentCurriculumList.vue?vue&type=style&index=0&id=404a3f0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a3f0f",
  null
  
)

export default component.exports